import styled from "@emotion/styled";
import { fontAngkor, fontMerriweather } from "@product/scmp-sdk";

import { Button } from "~/components/posties/button";

import Divider from "./divider.svg?url";

export const RootContainer = styled.div`
  position: relative;

  display: flex;

  inline-size: 100%;
  padding-block: 16px;
  padding-inline: 8px;

  border: 8px solid transparent;
  border-style: solid none solid;
  border-image: url(${Divider}) 30;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 24px;
    padding-inline: 16px;
  }
`;

export const LeftContainer = styled.div`
  inline-size: 100%;
`;

export const RightContainer = styled.div``;

export const ImageContainer = styled.div`
  position: relative;

  inline-size: 97.2px;
  margin-block: 2px;
  margin-inline: 12px 0;
  aspect-ratio: 97.2/72.9;
  &::after {
    position: absolute;
    inset-block-start: -2.43px;
    inset-inline-end: -2.43px;
    content: "";

    inline-size: 100%;
    block-size: 100%;

    border: 1.5px solid #000000;
    border-radius: 9.72px;
  }

  img {
    border-radius: 9.72px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 132px;

    aspect-ratio: 129.6/97.2;

    inline-size: 129.6px;

    &::after {
      inset-block-start: -3.24px;
      inset-inline-end: -3.24px;
    }
  }
`;

export const TitleText = styled.span`
  font-family: ${fontMerriweather};
`;

export const TitleContainer = styled.div`
  margin-block-end: 16px;

  color: #389810;
  font-size: 16px;
  font-size: 18px;
  line-height: 26px;
  line-height: 24px;
  letter-spacing: -0.54px;
  ${TitleText} {
    font-family: ${fontAngkor};
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 24px;
    line-height: 30px;
  }
`;

export const StyledButton = styled(Button)`
  color: #000000 !important;
`;
